import React from "react";

// The 42courses logo blob: the body plus its dot. Same geometry the home and
// For Teams heroes use, mirrored to give the three a bit of variety without
// drifting off the logo shape.
const BLOB_BODY =
  "M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z";
const BLOB_DOT =
  "M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z";

const Blob = ({ id, transform }: { id: string; transform: string }) => (
  <g id={id} transform={transform}>
    <path d={BLOB_BODY} />
    <path d={BLOB_DOT} />
  </g>
);

export const Icons = () => (
  <svg
    className="blob-defs"
    aria-hidden="true"
    style={{ position: "absolute", width: 0, height: 0 }}
  >
    <defs>
      <Blob id="workshop-blob-1" transform="translate(-100,-100)" />
      <Blob id="workshop-blob-2" transform="translate(100,-100) scale(-1,1)" />
      <Blob id="workshop-blob-3" transform="translate(-100,100) scale(1,-1)" />
    </defs>
  </svg>
);

export default Icons;
